// services/atualizarApartamento.ts
// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const atualizarMensagemService = async (token: string, data: any) => {
  const URL = `${Globais.DOMINIOBACK}/mensagens/status/${token}`;
  try {
    const response = await axios.patch(URL, data);
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};
